



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { IWorkflowComponentDisplayDefinition } from '../models/workflow-component-definition';
import { OtDataDrivenQuestion } from '../models/data-driven-question';
import { OtDataDrivenResponse, IResponsesGroupedByLayoutKey } from '../models/data-driven-response';
import WfParallelRadioButtonsEdit from '@/wf-components/edit-mode/wf-parallel-radio-buttons-edit.vue';
import { OtDataDrivenDefinition } from '../models/data-driven-definition';
import { OtDataDrivenInstance } from '../models/data-driven-instance';

@Component({
  components: {
    WfParallelRadioButtonsEdit,
  },
})
export default class WfParallelRadioButtonsDisplay extends Vue implements IWorkflowComponentDisplayDefinition {
  // * PROPS
  @Prop() public question!: OtDataDrivenQuestion;
  @Prop() public value!: OtDataDrivenResponse | null;
  @Prop() public readonly definition!: OtDataDrivenDefinition;
  @Prop() public readonly instance!: OtDataDrivenInstance;
  @Prop({ default: () => [] }) public readonly defaultValues!: IResponsesGroupedByLayoutKey[];
  @Prop({ default: false }) public disabled!: boolean;

  // * REFS

  // * DATA

  // * COMPUTED

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
}
